import React, { FC } from 'react';

const ArrowDownIcon: FC<{ color?: string }> = ({ color = '#4B5563' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none" style={{ color }}>
      <path
        d="M4.4335 4.73047C4.30283 4.73045 4.17615 4.68171 4.08682 4.59375L0.0184647 0.579102C0.0057454 0.566552 -0.00105418 0.548975 -9.00125e-05 0.531251C0.000965646 0.513483 0.00923141 0.496412 0.0233475 0.485352L0.626863 0.0146492C0.645681 1.6147e-05 0.671457 -0.00216443 0.692293 0.00683665L0.710847 0.019532L4.4335 3.69141L8.15616 0.0195313C8.17306 0.00307271 8.19706 -0.00250876 8.21866 0.00390631L8.23917 0.0146485L8.84268 0.485352C8.85686 0.496409 8.86604 0.513442 8.8671 0.53125C8.86806 0.548958 8.86124 0.566558 8.84854 0.579102L4.78018 4.59375C4.69088 4.68176 4.5642 4.73042 4.4335 4.73047Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowDownIcon;
